import { render, staticRenderFns } from "./FormHutangKurir.vue?vue&type=template&id=351586ac&scoped=true"
import script from "./FormHutangKurir.vue?vue&type=script&lang=js"
export * from "./FormHutangKurir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351586ac",
  null
  
)

export default component.exports